import { render, staticRenderFns } from "./word-usage-examples-sorting.vue?vue&type=template&id=35b89596&"
import script from "./word-usage-examples-sorting.vue?vue&type=script&lang=js&"
export * from "./word-usage-examples-sorting.vue?vue&type=script&lang=js&"
import style0 from "./word-usage-examples-sorting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35b89596', component.options)
    } else {
      api.reload('35b89596', component.options)
    }
    module.hot.accept("./word-usage-examples-sorting.vue?vue&type=template&id=35b89596&", function () {
      api.rerender('35b89596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-usage-examples/word-usage-examples-sorting.vue"
export default component.exports